// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Util  {
    _originalTypeClassName = "Loom.BO.Util";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Util.translate = translateService;
}
this.Id = null;
this.Value = null;
this.Display = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Value:any;
Display:any;

static CountSpecificWeekdays(startDate: any,endDate: any,daysOfWeek: any): any{let dayCount = 0;
for (var date = startDate; (new Date(date).getTime()) <= (new Date(endDate).getTime()); date = (moment(date).add(1, "d")).toDate()) {
for (let _iday = 0; _iday < (daysOfWeek == null ? 0 : daysOfWeek.length); _iday++) {let day = daysOfWeek[_iday];console.debug(CLMS.Framework.String.Format("Date's: {0}, day is: {1} and input day is: {2}", CLMS.Framework.DateTime.ToString(date, "DDD MMM yyyy"), moment(date).day(), day?.toString()));if ((moment(date).day()?.toString() == day?.toString())) {dayCount = Joove.Common.safeNumber(dayCount) + Joove.Common.safeNumber(1);}}}

return dayCount;
}
static DoDateRangesOverlap(range1Start: any,range1End: any,range2Start: any,range2End: any): any{let overlap = (new Date(range1Start).getTime()) <= (new Date(range2End).getTime()) && (new Date(range1End).getTime()) >= (new Date(range2Start).getTime());
return overlap;
}
static DoMonthPeriodsOverlap(range1Start: any,range1End: any,range2Start: any,range2End: any): any{if ((!((range1Start != null)))) {throw Error("Range1 Start date is null!");}
if ((!((range2Start != null)))) {throw Error("Range2 Start date is null!");}
if ((!((range1End != null)))) {range1End = moment([2100, (12) - 1, 1]).toDate();}
if ((!((range2End != null)))) {range2End = moment([2100, (12) - 1, 1]).toDate();}
let range1StartMonth = new Date(new Date(moment([moment(range1Start).year(), ((moment(range1Start).month() + 1)) - 1, 1]).toDate())?.setHours(0, 0, 0, 0));
let range1EndMonth = new Date(new Date(moment([moment(range1End).year(), ((moment(range1End).month() + 1)) - 1, 1]).toDate())?.setHours(0, 0, 0, 0));
let range2StartMonth = new Date(new Date(moment([moment(range2Start).year(), ((moment(range2Start).month() + 1)) - 1, 1]).toDate())?.setHours(0, 0, 0, 0));
let range2EndMonth = new Date(new Date(moment([moment(range2End).year(), ((moment(range2End).month() + 1)) - 1, 1]).toDate())?.setHours(0, 0, 0, 0));
return Domain.Util.DoDateRangesOverlap(range1StartMonth, range1EndMonth, range2StartMonth, range2EndMonth);
}
static DoMonthPeriodsOverlap_OLD(period1StartMonth: any,period1EndMonth: any,period2StartMonth: any,period2EndMonth: any): any{let period1StartTimestamp = Domain.Util.GetMonthTimestamp(period1StartMonth, false);
let period1EndTimestamp = Domain.Util.GetMonthTimestamp(period1EndMonth, true);
let period2StartTimestamp = Domain.Util.GetMonthTimestamp(period2StartMonth, false);
let period2EndTimestamp = Domain.Util.GetMonthTimestamp(period2EndMonth, true);
let overlap = false;
if ((CLMS.Framework.Number.GreaterThanOrEqual(() => period2StartTimestamp, () => period1StartTimestamp) && CLMS.Framework.Number.LessThanOrEqual(() => period2StartTimestamp, () => period1EndTimestamp))) {overlap = true;}else if ((CLMS.Framework.Number.GreaterThanOrEqual(() => period2EndTimestamp, () => period1StartTimestamp) && CLMS.Framework.Number.LessThanOrEqual(() => period2EndTimestamp, () => period1EndTimestamp))) {overlap = true;}else if ((CLMS.Framework.Number.LessThanOrEqual(() => period2StartTimestamp, () => period1StartTimestamp) && CLMS.Framework.Number.GreaterThanOrEqual(() => period2EndTimestamp, () => period1EndTimestamp))) {overlap = true;}
console.debug(CLMS.Framework.String.Format("Period1 : {0} - {1} does {2} overlap with period 2: {3} - {4}", CLMS.Framework.DateTime.ToString(period1StartMonth, "MMM yyyy"), CLMS.Framework.DateTime.ToString(period1EndMonth, "MMM yyyy"), (overlap ? "INDEED" : "NOT"), CLMS.Framework.DateTime.ToString(period2StartMonth, "MMM yyyy"), CLMS.Framework.DateTime.ToString(period2EndMonth, "MMM yyyy")));
return overlap;
}
static GenerateRandomPassword(length: any): any{if ((CLMS.Framework.Number.LessThan(() => length, () => 4))) {throw Error("Password length must be at least 4 characters long.");}
let lowerCaseStr = "abcdefghijklmnopqrstuvwxyz";
let upperCaseStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
let digitsStr = "1234567890";
let symbolsStr = "@#$!%*?&";
let password = [];
password?.add(lowerCaseStr[System.Random.integer(0, lowerCaseStr?.length)]);
password?.add(upperCaseStr[System.Random.integer(0, upperCaseStr?.length)]);
password?.add(digitsStr[System.Random.integer(0, digitsStr?.length)]);
password?.add(symbolsStr[System.Random.integer(0, symbolsStr?.length)]);
let allChars = lowerCaseStr + upperCaseStr + digitsStr + symbolsStr;
for (var i = 4; CLMS.Framework.Number.LessThan(() => i, () => length); i = Joove.Common.safeNumber(i) + Joove.Common.safeNumber(1)) {
password?.add(allChars[System.Random.integer(0, allChars?.length)]);}

for (var i = Joove.Common.safeNumber(password?.length) - Joove.Common.safeNumber(1); CLMS.Framework.Number.GreaterThan(() => i, () => 0); i = Joove.Common.safeNumber(i) - Joove.Common.safeNumber(1)) {
let j = System.Random.integer(0, Joove.Common.safeNumber(i) + Joove.Common.safeNumber(1));let temp = password[i];password[i] = password[j];password[j] = temp;}

return CLMS.Framework.String.Join("", password);
}
static GenerateRandomPasswordSimple(): any{let validChars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890!@#$%^&*()-_=+<>";
let password = "";
for (var i = 0; CLMS.Framework.Number.LessThan(() => i, () => 16); i = Joove.Common.safeNumber(i) + Joove.Common.safeNumber(1)) {
let index = System.Random.integer(0, validChars?.length);password = password + validChars?.substr(index, 1);}

return password;
}
static GetDateRangeDurationInMonths(start: any,end: any): any{return Joove.Common.safeNumber((Joove.Common.safeNumber((moment(end).month() + 1)) - Joove.Common.safeNumber((moment(start).month() + 1)))) + Joove.Common.safeNumber(12) * Joove.Common.safeNumber((Joove.Common.safeNumber(moment(end).year()) - Joove.Common.safeNumber(moment(start).year()))) + Joove.Common.safeNumber(1);
}
static GetMaxDate(dates: any): any{if ((dates?.linq?.any((a) => !((a != null)) || CLMS.Framework.Number.LessThan(() => moment(a).year(), () => 1900)))) {throw Error("Dates must have valid values!");}
return dates?.linq?.orderBy((dt) => dt)?.toArray()?.linq?.lastOrDefault();
}
static GetMinDate(dates: any): any{if ((dates?.linq?.any((a) => !((a != null)) || CLMS.Framework.Number.LessThan(() => moment(a).year(), () => 1900)))) {throw Error("Dates must have valid values!");}
return dates?.linq?.orderBy((dt) => dt)?.toArray()?.linq?.where()?.firstOrDefault(null);
}
static GetMonth(i: any): any{switch (i) {case 1:
{
return "January";break;}
case 2:
{
return "February";break;}
case 3:
{
return "March";break;}
case 4:
{
return "April";break;}
case 5:
{
return "May";break;}
case 6:
{
return "June";break;}
case 7:
{
return "July";break;}
case 8:
{
return "August";break;}
case 9:
{
return "September";break;}
case 10:
{
return "October";break;}
case 11:
{
return "November";break;}
case 12:
{
return "December";break;}
}
return "";
}
static GetMonthTimestamp(dt: any,isForEnd: any): any{if ((!((dt != null)))) {return (isForEnd ? Joove.Common.safeNumber(3000) * Joove.Common.safeNumber(100) : -1);}
return ((dt != null) ? Joove.Common.safeNumber(moment(dt).year()) * Joove.Common.safeNumber(100) + Joove.Common.safeNumber((moment(dt).month() + 1)) : Joove.Common.safeNumber(2000) * Joove.Common.safeNumber(100) + Joove.Common.safeNumber(12));
}
static GetPercentage(val: any,total: any): any{return ((CLMS.Framework.Number.Equal(() => total, () => null) || CLMS.Framework.Number.Equal(() => total, () => 0)) ? 0 : (Joove.Common.safeNumber(100) * Joove.Common.safeNumber(val) / Joove.Common.safeNumber(total)));
}
static GetSpecificWeekdaysOccurences(startDate: any,endDate: any,daysOfWeek: any): any{let dates = [];
for (var date = startDate; (new Date(date).getTime()) <= (new Date(endDate).getTime()); date = (moment(date).add(1, "d")).toDate()) {
let ser = new CLMS.Framework.Utilities.Serializer<any>();let daySearch = ser.ParseEnum(moment(date).day()?.toString());if ((daysOfWeek?.linq?.contains(daySearch))) {dates?.add(new Date(new Date(date)?.setHours(0, 0, 0, 0)));}}

console.debug(CLMS.Framework.String.Format("Period: {0} - {1} contains {2} occurences of [{3}]", CLMS.Framework.DateTime.ToString(startDate, "dd/MM/yyyy"), CLMS.Framework.DateTime.ToString(endDate, "dd/MM/yyyy"), dates?.length, CLMS.Framework.String.Join(", ", daysOfWeek)));
return dates;
}
static GetStartAndEndDatesOfMonth(month: any): any{let start = new Date(new Date(moment([moment(month).year(), ((moment(month).month() + 1)) - 1, 1]).toDate())?.setHours(0, 0, 0, 0));
let end = moment([moment(month).year(), ((moment(month).month() + 1)) - 1, 1]).toDate();
end = new Date(new Date((moment((moment(end).add(1, "M")).toDate()).add(-1, "d")).toDate())?.setHours(0, 0, 0, 0));
return [start, end];
}
static GetYearOptions(person: any): any{let years = [];
let allYears = new Domain.Util();
allYears.Display = "All";
allYears.Value = 0;
let existingYears = person?.LeaveBalances?.linq?.select((l) => l?.Year)?.toArray()?.linq?.distinct()?.toArray()?.linq?.orderBy((y) => y)?.toArray();
for (let _iexistingYear = 0; _iexistingYear < (existingYears == null ? 0 : existingYears.length); _iexistingYear++) {let existingYear = existingYears[_iexistingYear];let yy = new Domain.Util();yy.Display = Joove.Common.safeNumber(existingYear) + "";yy.Value = existingYear;years?.add(yy);}
if (person?.StartDate == null || CLMS.Framework.Number.LessThan(() => moment(person.StartDate).year(), () => 1800)) {years?.insert(0, allYears);return years;}
let startYear = moment(person?.StartDate).year();
let endYear = ((!((person?.EndDate != null)) || CLMS.Framework.Number.LessThan(() => moment(person.EndDate).year(), () => startYear)) ? Joove.Common.safeNumber(moment(moment().toDate()).year()) + Joove.Common.safeNumber(1) : moment((moment(person?.EndDate).add(1, "y")).toDate()).year());
if (CLMS.Framework.Number.GreaterThan(() => startYear, () => endYear)) {years?.insert(0, allYears);return years;}
for (var i = endYear; CLMS.Framework.Number.GreaterThanOrEqual(() => i, () => startYear); i = Joove.Common.safeNumber(i) - Joove.Common.safeNumber(1)) {
if (years?.linq?.any((y) => CLMS.Framework.Number.Equal(() => y.Value, () => i))) {continue;}let year = new Domain.Util();year.Display = Joove.Common.safeNumber(i) + "";year.Value = i;years?.add(year);}

years = years?.linq?.orderByDescending((y) => y?.Value)?.toArray();
years?.insert(0, allYears);
return years;
}
static GetYearPicker(yearsBefore: any,yearsAfter: any): any{let years = [];
let startYear = Joove.Common.safeNumber(moment(moment().toDate()).year()) - Joove.Common.safeNumber(yearsBefore);
let endYear = Joove.Common.safeNumber(moment(moment().toDate()).year()) + Joove.Common.safeNumber(yearsAfter);
for (var i = endYear; CLMS.Framework.Number.GreaterThanOrEqual(() => i, () => startYear); i = Joove.Common.safeNumber(i) - Joove.Common.safeNumber(1)) {
if (years?.linq?.any((y) => CLMS.Framework.Number.Equal(() => y.Value, () => i))) {continue;}let year = new Domain.Util();year.Display = Joove.Common.safeNumber(i) + "";year.Value = i;years?.add(year);}

return years;
}
static GetYearsOfRange(person: any): any{let years = [];
return years;
}
static GracefullyHandleException(e: any): any{let ex = e;
while (((ex as any)?.innerException != null)) {ex = (ex as any)?.innerException;}
console.error(ex?.GetType());
console.error(ex?.message);
let message = ex?.message;
if ((message?.indexOf("Arithmetic overflow") === 0)) {message = "Out of range value!";}
throw Error(message);
}
static IsDateWithinPeriod(dt: any,start: any,end: any): any{return ((new Date(start).getTime()) <= (new Date(new Date(new Date(dt)?.setHours(0, 0, 0, 0))).getTime()) && (new Date(new Date(new Date(dt)?.setHours(0, 0, 0, 0))).getTime()) <= (new Date(end).getTime()));
}
static IsPeriod1ContainedInPeriod2(period1StartMonth: any,period1EndMonth: any,period2StartMonth: any,period2EndMonth: any): any{let period1StartTimestamp = Domain.Util.GetMonthTimestamp(period1StartMonth, false);
let period1EndTimestamp = Domain.Util.GetMonthTimestamp(period1EndMonth, true);
let period2StartTimestamp = Domain.Util.GetMonthTimestamp(period2StartMonth, false);
let period2EndTimestamp = Domain.Util.GetMonthTimestamp(period2EndMonth, true);
let overlap = false;
if ((CLMS.Framework.Number.GreaterThanOrEqual(() => period1StartTimestamp, () => period2StartTimestamp) && CLMS.Framework.Number.LessThanOrEqual(() => period1StartTimestamp, () => period2EndTimestamp))) {overlap = true;}
if ((CLMS.Framework.Number.GreaterThanOrEqual(() => period1EndTimestamp, () => period2StartTimestamp) && CLMS.Framework.Number.LessThanOrEqual(() => period1EndTimestamp, () => period2EndTimestamp))) {overlap = true;}
console.debug(CLMS.Framework.String.Format("Period1 : {0} - {1} is {2} included with period 2: {3} - {4}", CLMS.Framework.DateTime.ToString(period1StartMonth, "MMM yyyy"), CLMS.Framework.DateTime.ToString(period1EndMonth, "MMM yyyy"), (overlap ? "INDEED" : "NOT"), CLMS.Framework.DateTime.ToString(period2StartMonth, "MMM yyyy"), CLMS.Framework.DateTime.ToString(period2EndMonth, "MMM yyyy")));
return overlap;
}
static IsRangeOneMonth(from: any,to: any): any{return CLMS.Framework.Number.Equal(() => moment(from).year(), () => moment(to).year()) && CLMS.Framework.Number.Equal(() => (moment(from).month() + 1), () => (moment(to).month() + 1)) && CLMS.Framework.Number.Equal(() => moment(from).date(), () => 1) && CLMS.Framework.Number.Equal(() => moment((moment(to).add(1, "d")).toDate()).date(), () => 1);
}
static MonthPicker(): any{let months = [];
for (var i = 1; CLMS.Framework.Number.LessThanOrEqual(() => i, () => 12); i = Joove.Common.safeNumber(i) + Joove.Common.safeNumber(1)) {
let month = new Domain.Util();month.Value = i;month.Display = Domain.Util.GetMonth(i);months?.add(month);}

return months;
}
static YearPicker(range1Start: any,range1End: any,range2Start: any,range2End: any): any{return (new Date(range1Start).getTime()) <= (new Date(range2End).getTime()) && (new Date(range1End).getTime()) >= (new Date(range2Start).getTime());
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}